"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObjectToQuery = exports.mergeBaseUri = exports.mergePaths = void 0;
var ParseQueryError_1 = require("../errors/ParseQueryError");
var query_1 = require("./internal/query");
var parsers_1 = require("./parsers");
var mergePaths = function (left, right) {
    var leftPath = left.replace(/\/$/, '');
    var rightPath = right.replace(/^\//, '');
    return "".concat(leftPath, "/").concat(rightPath);
};
exports.mergePaths = mergePaths;
var mergeBaseUriPiece = function (baseUriPiece, extensionPiece) {
    if (typeof extensionPiece === 'undefined') {
        return baseUriPiece;
    }
    if (typeof extensionPiece === 'function') {
        return extensionPiece(baseUriPiece);
    }
    return extensionPiece;
};
var mergeBaseUri = function (baseUri, extension) {
    var parsedBaseUri = (0, parsers_1.parseURI)(baseUri);
    var scheme = mergeBaseUriPiece(parsedBaseUri.scheme, extension.scheme);
    var host = mergeBaseUriPiece(parsedBaseUri.host, extension.host);
    var port = mergeBaseUriPiece(parsedBaseUri.port, extension.port);
    var path = mergeBaseUriPiece(parsedBaseUri.path, extension.path);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var query = mergeBaseUriPiece(parsedBaseUri.query || '', extension.query);
    return {
        host: host,
        path: path,
        port: port,
        query: query,
        scheme: scheme,
    };
};
exports.mergeBaseUri = mergeBaseUri;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getArrayQuery = function (arrParam, key, transformBodyToLegacyString) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var toKey = function (val, index) {
        return transformBodyToLegacyString ? (0, query_1.makeQueryParam)("".concat(key, "[").concat(index, "]"), val) : (0, query_1.toQueryParam)(key, val);
    };
    return arrParam.map(toKey).join('&');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getObjectQuery = function (objParam, key, transformBodyToLegacyString) {
    if (!transformBodyToLegacyString) {
        throw new ParseQueryError_1.ParseQueryError("Can't parse query string. Value type shouldn't be \"object\". Key: \"".concat(key, "\""));
    }
    return (0, query_1.makeQueryParam)(key, objParam);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var transformObjectToQuery = function (obj, transformBodyToLegacyString) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var withoutEmpty = function (key) { return !!(key.length && obj[key] !== undefined); };
    var makeQuery = function (key) {
        var item = obj[key];
        switch (true) {
            case item instanceof Array:
                return getArrayQuery(item, key, transformBodyToLegacyString);
            case item !== null && typeof item === 'object':
                return getObjectQuery(item, key, transformBodyToLegacyString);
            default:
                return (0, query_1.toQueryParam)(key, item);
        }
    };
    return Object.keys(obj).filter(withoutEmpty).map(makeQuery).join('&');
};
exports.transformObjectToQuery = transformObjectToQuery;
//# sourceMappingURL=helpers.js.map